/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_STRONG,
  BUTTON_THEME_PRIMARY,
  ButtonProps,
  CUSTOM_ICON_DASHBOARD_CUSTOMISE,
  DIALOG_SIZE_LG,
  DIALOG_TYPE_WIZARD,
  DialogProps,
  ICON_WIDGETS,
} from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../Constants/Strings.constants';
import { AddComponentToSetProps } from './AddComponentToSet.props';
import { getAddComponentToSetSteps } from './utils/GetAddComponentToSetSteps/GetAddComponentToSetSteps';

/**
 * Add to set button.
 */
export const AddComponentToSet = (props: AddComponentToSetProps): JSX.Element => {
  const { t } = useTranslation();

  // Labels
  const labels = {
    addToSet: t(COMPONENT_SERVICE_STRINGS.addToSet),
  };

  // Configs
  const buttonProps: ButtonProps = {
    disabled: props.disabled,
    format: BUTTON_FORMAT_STRONG,
    icon: CUSTOM_ICON_DASHBOARD_CUSTOMISE,
    text: labels.addToSet,
    theme: BUTTON_THEME_PRIMARY,
  };

  const wizardProps: DialogProps = {
    classes: 'add-to-set__wizard',
    dialogSize: DIALOG_SIZE_LG,
    dialogType: DIALOG_TYPE_WIZARD,
    heading: labels.addToSet,
    icon: ICON_WIDGETS,
    scrollOnOverflow: true,
    stateHandler: useDialogStore,
    wizardSteps: getAddComponentToSetSteps({ ...props }),
  };

  // Wizard launcher
  return <DialogLauncher buttonProps={buttonProps} dialogProps={wizardProps} />;
};
